import { useFormik } from "formik";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import PostApi from "api/postApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import {
  COLOR_BAR_DETAIL_REVIEW_STATUS,
  LIST_OPTION_BAR_DETAIL_REVIEW_STATUS,
} from "helpers/constans";
import DropdownAsyncBars from "components/Common/DropdownAsyncBars";
import DropdownAsyncUsers from "components/Common/DropdownAsyncUsers";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import UploadImage from "components/Common/UploadImage";

export default function CreateEditFeedBartender({
  setIsOpen,
  item,
  setItemToEdit,
  loadTableData,
  setLinkImage,
}: any) {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedManager, setSelectedManager] = useState<any>(null);
  const [selectedBarStore, setSelectedBarStore] = useState<any>(null);
  const isEdit = item;

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading((_prev) => false);
      const data = {
        post: {
          title: values?.title,
          contents: values?.contents,
          type: 1,
          bar_id: values?.bar_id,
          user_id: values?.user_id,
          is_active: values?.is_active,
        },
        files: values?.files,
      };

      const response: any = isEdit
        ? await PostApi?.updatePost(item?.id, data)
        : await PostApi?.createPost(data);

      if (response?.data) {
        //  dispatch(onGetPosts(query));
        loadTableData();
        setIsLoading((_prev) => false);
        setIsOpen(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsLoading(false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading(false);
      toast(`Please re-check your data`);
      return error;
    }
  };

  const validationSchema = Yup.object({
    user_id: Yup.string().required(`${t("This field is required")}`),
    bar_id: Yup.string().required(`${t("This field is required")}`),
    title: Yup.string()
      .nullable()
      .max(5000, `${t("Title must be at most 5000 characters long")}`),
    contents: Yup.string()
      .required(`${t("This field is required")}`)
      .max(50000, `${t("Contents must be at most 50000 characters long")}`),
    files: Yup.array()
      .min(1, `${t("This field is required")}`)
      .required(`${t("This field is required")}`),
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      contents: "",
      is_active: 1,
      bar_id: "",
      user_id: "",
      type: 1,
      files: [],
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const onCloseClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  const formatPositionPreviewImage = (files: any, activeImage: any) => {
    const filesFormat = files?.filter(
      (item: any) => item?.url !== activeImage?.url
    );

    return [activeImage, ...filesFormat];
  };

  const formatBarSelected = (data: any) => {
    return {
      value: String(data?.id),
      label: (
        <div className="d-flex align-list-center gap-2">
          <div>{`${data?.nickname}`}</div>
        </div>
      ),
      data: data,
    };
  };

  const formatUserSelected = (data: any) => {
    return {
      value: String(data?.id),
      label: (
        <div className="d-flex align-items-center gap-2">
          <div>
            {`${data?.nickname ? data?.nickname + " -" : ""} ${data?.email}`}
          </div>
        </div>
      ),
      data: data,
    };
  };

  useEffect(() => {
    if (item) {
      if (item?.bar?.id) {
        const formatBarOption = formatBarSelected(item?.bar);
        setSelectedBarStore(formatBarOption);
        formik.setFieldValue("bar_id", item?.bar?.id);
      }

      if (item?.user_profile) {
        const formatManagerOption = formatUserSelected(item?.user_profile);
        setSelectedManager(formatManagerOption);
        formik.setFieldValue("user_id", item?.user_profile?.id);
      }
      formik.setFieldValue("files", item?.files);
      formik.setFieldValue("title", item?.title);
      formik.setFieldValue("contents", item?.contents);
      formik.setFieldValue("is_active", item?.is_active);
    }
  }, [item]);

  const [barIdForSearch, setBarIdForSearch] = useState<string>("");

  return (
    <Modal isOpen={true} centered={true} scrollable={false} size="lg">
      <ModalHeader toggle={isLoading ? () => {} : onCloseClick}>
        {isEdit ? t("Update Feed") : t("Create Feed Bartender")}
      </ModalHeader>
      <ModalBody className="py-3 px-4">
        <div className="mb-4">
          <Progress
            value={100 - (100 / 5) * Number(Object.keys(formik.errors).length)}
            color="primary"
            className="animated-progress progress-sm"
          />
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="row g-3">
            <Col xxl={12}>
              <label className="form-label">
                {t("Store List")}
                <span className="text-danger"> *</span>
              </label>

              <DropdownAsyncBars
                name="bar_id"
                onChangeSelect={(event: any) => {
                  formik.setFieldValue("bar_id", event?.value);
                  setSelectedBarStore(event);
                  setBarIdForSearch(event?.value);
                }}
                isMulti={false}
                placeholder={`${t("Select Store")}...`}
                isShowIconCheck={false}
                isAllOption={false}
                listCheckedUsers={selectedBarStore}
                key={"bar-async"}
              />

              {formik.touched.bar_id && formik.errors.bar_id ? (
                <div className="text-danger mt-2">{formik.errors.bar_id}</div>
              ) : null}
            </Col>

            <Col xxl={12}>
              <label className="form-label">
                {t("Bartender")}
                <span className="text-danger"> *</span>
              </label>

              <DropdownAsyncUsers
                name="bartender"
                onChangeSelect={(event: any) => {
                  formik.setFieldValue("user_id", event?.value);
                  setSelectedManager(event);
                }}
                isMulti={false}
                placeholder={`${t("Select Bartender")}...`}
                isShowIconCheck={false}
                isAllOption={false}
                paramsTypeUsers={2}
                listCheckedUsers={selectedManager}
                keywordSearch={barIdForSearch}
                key={`list-${barIdForSearch || "all"}`}
                defaultParams={{ is_active: 1 }}
              />

              {formik.touched.user_id && formik.errors.user_id ? (
                <div className="text-danger mt-2">{formik.errors.user_id}</div>
              ) : null}
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <Label htmlFor="name-bar" className="form-label">
                  {t("Title")}
                </Label>
                <Input
                  name="title"
                  type="text"
                  className="form-control"
                  placeholder={t("Enter your title")}
                  value={formik?.values?.title}
                  onChange={(event: any) =>
                    formik.setFieldValue("title", event?.target?.value)
                  }
                />
                {formik.touched.title && formik.errors.title ? (
                  <div className="text-danger mt-2">{formik.errors.title}</div>
                ) : null}
              </div>
            </Col>

            <Col xxl={12}>
              <label className="form-label">
                {t("Content")}
                <span className="text-danger"> *</span>
              </label>
              <textarea
                className="form-control"
                name="contents"
                value={formik?.values?.contents}
                placeholder={`${t("Content")}...`}
                onChange={(event: any) =>
                  formik.setFieldValue("contents", event?.target?.value || "")
                }
                style={{ height: 120 }}
              />
              {formik.touched.contents && formik.errors.contents ? (
                <div className="text-danger mt-2">{formik.errors.contents}</div>
              ) : null}
            </Col>

            <Col xxl={12}>
              <label className="form-label">
                {t("Status")}
                <span className="text-danger"> *</span>
              </label>

              <DropdownStatusNew
                name="is_active"
                dataList={LIST_OPTION_BAR_DETAIL_REVIEW_STATUS || []}
                placeholder={`${t("Status")}...`}
                className="dropdown-status-rounded"
                classNamePrefix="name-prefix"
                initialValue={formik.values.is_active}
                onChangeSelect={(event: any) => {
                  formik.setFieldValue("is_active", event?.value);
                }}
                isHasOptionAll={false}
                colors={COLOR_BAR_DETAIL_REVIEW_STATUS}
              />

              {formik.touched.is_active && formik.errors.is_active ? (
                <div className="text-danger mt-2">
                  {formik.errors.is_active}
                </div>
              ) : null}
            </Col>

            <Col xxl={12}>
              <label className="form-label">
                {t("Files")}
                <span className="text-danger"> *</span>
              </label>

              <UploadImage
                data={formik.getFieldProps("files")?.value}
                setLinkImage={setLinkImage}
                formik={formik}
              />
            </Col>

            <div className="col-lg-12">
              <div className="hstack gap-2 justify-content-end">
                <button
                  className="btn btn-primary fs-14"
                  color="success"
                  type="submit"
                  disabled={isLoading}
                  style={{ width: "120px" }}
                >
                  {isLoading ? (
                    <Spinner size="sm" className="me-2"></Spinner>
                  ) : (
                    <>{isEdit ? t("Button Update") : t("Button Create")}</>
                  )}
                </button>
                <button
                  className="btn btn-secondary fs-14"
                  color="light"
                  type="button"
                  onClick={onCloseClick}
                  disabled={isLoading}
                  style={{ width: "100px" }}
                >
                  {t("Button Close")}
                </button>
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}
